export default __webpack_public_path__ + "static/cloudator-1-thumb-cc364edb408e05a8c7111299edd9d29c.png";